import React from 'react';
import Box from '@mui/material/Box';

export default function MobileTabPanel({ children, value, index, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`mobile-tabpanel-${index}`}
            aria-labelledby={`mobile-tab-${index}`}
            style={{ height: '100%', overflow: 'hidden' }}
            {...other}
        >
            {value === index && (
                <Box sx={{ height: '100%', overflow: 'auto' }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

export function a11yProps(label) {
    return {
        id: `mobile-tab-${label}`,
        'aria-controls': `mobile-tabpanel-${label}`
    };
}
